module.exports = __webpack_public_path__ + "static/img/rank_162.edaf815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_162.png
// module id = T6sY
// module chunks = 0